<template>
  <v2-modal
    :show="visible"
    size="sm"
    title="Confirmation"
    @close="$emit('close')"
  >
    <p class="v2-confirm__text">
      Are you sure you want to close? All unsaved changes will be lost.
    </p>
    <template #footer>
      <v2-button
        variant="outline"
        @click="$emit('close')"
      >
        Cancel
      </v2-button>
      <v2-button
        @click="$emit('ok')"
      >
        OK
      </v2-button>
    </template>
  </v2-modal>
</template>

<script>
import V2Modal from '@/components/v2/V2Modal.vue'
import V2Button from '@/components/v2/V2Button.vue'

export default {
  name: 'V2ConfirmationModal',
  components: {
    V2Modal,
    V2Button,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.v2-confirm__text {
  font-size: 0.875rem;
  color: var(--v2-foreground);
  margin: 0;
  line-height: 1.5;
}
</style>
